import Color from '../Color.mjs'
import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    name: '文件',
    type: 'DOC',
}
